import _ from 'lodash';
import { ControlWithScenarios } from './types';

export const calculateSelectionState = (
  scenarios: ControlWithScenarios['scenarios'],
  controlSelections: Record<string, boolean> = {},
) => {
  const linkedScenarios = _.filter(scenarios, 'isLinked');
  const availableScenarios = _.filter(scenarios, (s) => !s.isLinked);
  const selectedScenarios = _.filter(availableScenarios, (s) => controlSelections[s.scenario.id] === true);

  const totalSelectedCount = selectedScenarios.length + linkedScenarios.length;
  const totalScenariosCount = scenarios.length;

  return {
    totalSelectedCount,
    totalScenariosCount,
    availableScenariosCount: availableScenarios.length,
  };
};

export const getCheckboxState = (
  totalSelectedCount: number,
  totalScenariosCount: number,
  availableScenariosCount: number,
) => ({
  isChecked: totalSelectedCount === totalScenariosCount && totalScenariosCount > 0,
  indeterminate: totalSelectedCount > 0 && totalSelectedCount < totalScenariosCount,
  disabled: availableScenariosCount === 0,
});
